module.exports = __webpack_public_path__ + "img/logo_b.4a5d9e31.png";